import { Header } from './shared';

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Header />

      <article className="mt-4">{children}</article>

      <footer className="mb-10 mt-20">
        <div className="container mx-auto flex flex-col gap-4">
          <section className="flex items-center justify-between">
            <img src="/images/atp-logo.svg" alt="Checkout" />
            <img src="/images/accredited.png" className="h-[2.5rem]" alt="accredited business" />
          </section>

          <section className="flex items-baseline justify-between gap-4">
            <div className="flex flex-col items-start gap-0 md:flex-row md:items-center md:gap-4">
              <a href="tel:888-900-8380" className="whitespace-nowrap text-base text-secondary-dark">
                P: 888-900-8380
              </a>
              <a href="mailto:info@achievetestprep.com" className="whitespace-nowrap text-base text-secondary-dark">
                E: info@achievetestprep.com
              </a>
            </div>
            <div className="text-[0.5rem] text-secondary-dark">
              © 2025 Achieve Test Prep. All rights reserved. *Achieve Test Prep is not a college or university. We do
              not issue a college degree, diploma or course credit.
            </div>
          </section>

          <section className="flex items-center justify-end gap-4">
            <a
              href="https://www.achievetestprep.com/terms"
              target="_blank"
              className="whitespace-nowrap text-xs font-light text-secondary-dark"
            >
              Terms
            </a>
            <a
              href="https://www.achievetestprep.com/privacy"
              target="_blank"
              className="whitespace-nowrap text-xs font-light text-secondary-dark"
            >
              Privacy
            </a>
          </section>
        </div>
      </footer>
    </>
  );
}
